import React, { Component } from 'react'

import styled from 'styled-components'

import CElement from '../CElement'

const DotContentViewInner = styled.div`
border-radius: 6px;
line-height: 1.7;
white-space: pre-wrap;
`

const ImageDotContentViewInner = styled(DotContentViewInner)`
background-color: white;
padding: 0;
overflow: hidden;
vertical-align: bottom;
margin: calc(1.7em * 1.5) 0;
`

const Separator = styled.div`
height: 0;
border-top: 1px solid black;
display: border-box;
margin: 1.7em 0;
`

class CElementView extends Component {
  constructor(props) {
    super(props)
    this.state = { text : null, imageUrl : null }
  }
  
  componentDidMount() {
    this._updateStatesWith(this.props.element)
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) {
      return
    }
   this._updateStatesWith(this.props.element)
  }
  
  _updateStatesWith(element) {
    if (element === null) {
      return
    }
    
    switch (element.kind) {
      case CElement.KIND.TEXT:
      element.text(text => this.setState({ text : text }))
      break
      case CElement.KIND.IMAGE:
      this.setState({ imageUrl : element.imageUrl() })
      break
      case CElement.KIND.SEPARATOR:
      break // Do nothing
      default:
      console.warn(`Unsupported dot type: ${element.dotType}`)
    }
  }
  
  render() {
    const { text, imageUrl } = this.state
    if (text !== null) {
      if (text.indexOf('\n') >= 0) {
        return <DotContentViewInner {...this.props}>{text}</DotContentViewInner>
      } else {
        return <DotContentViewInner {...this.props}><h1>{text}</h1></DotContentViewInner>
      }
    } else if (imageUrl !== null) {
      return <ImageDotContentViewInner {...this.props}><img src={imageUrl} style={{maxWidth : '100%', display : 'block'}} alt="マンダラ"/></ImageDotContentViewInner>
    } else if (this.props.element.kind === CElement.KIND.SEPARATOR) {
      return <Separator />
    } else {
      return null
    }
  }
}

export default CElementView


// WEBPACK FOOTER //
// ./src/App/View/CElementView.js